export default {
  align: 'center',
  emptyBtn: false,
  submitText: '保存',
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      span: 8,
      search: true,
      cell: true,
      clearable: false,
      disabled: false,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          message: '请选择车场名称',
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',

    },


    {
      label: '区域',
      prop: 'regions',
      hide: true,
      span: 8,
      type: 'tree',
      multiple: true,
      checkStrictly: true,
      dataType: 'string',
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },

    },


  ],
};

